import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_SKIN_TYPES = 'GET_SKIN_TYPES';
export const GET_SKIN_TYPES_SUCCESS = 'GET_SKIN_TYPES_SUCCESS';
export const GET_SKIN_TYPES_FAILURE = 'GET_SKIN_TYPES_FAILURE';

// Action Creators
export const getSkinTypes = () => ({
  type: GET_SKIN_TYPES,
});

export const getSkinTypesSuccess = (data) => ({
  type: GET_SKIN_TYPES_SUCCESS,
  payload: data,
});

export const getSkinTypesFailure = (error) => ({
  type: GET_SKIN_TYPES_FAILURE,
  payload: error,
});

// Thunk Function
export const getSkinTypesCallAPI = (external) => {
  return async (dispatch) => {
    dispatch(getSkinTypes());
    try {
      const response = await getMethodWithToken(url.skinTypes);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getSkinTypesSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(getSkinTypesFailure(response?.data));
      }
    } catch (error) {
      dispatch(getSkinTypesFailure(error?.message));
    }
  };
};
